import { ErrorView } from "common/components/error";
import { FetchErrorRetry } from "common/helpers/errors";
import { Component } from "react";

import { Loader } from "common/helpers/HorizontalLoader";
import { TrendlineTopChart } from "./trendlineLineChart";
import { TrendlineBottomChart } from "./trendlineBarChart";
import { TrendlineSummary } from "./trendlineSummary";
import { fetchChartData, sortAndFillGaps } from "../widgetHelper";

export class TrendlineTabBody extends Component {
    static processData(props, dateRangeIndex, data) {
        const days = props.dateRanges[dateRangeIndex].days;
        const startDate = props.dateRanges[dateRangeIndex].startDate;
        const sortedData = sortAndFillGaps(days, startDate, data);
        return sortedData.map((r) => ({ topField: Math.abs(r[props.countField]) || null, bottomField: Math.abs(r[props.countField2]) || null }));
    }
    
    static generateAxisArray(daysInRange, startDate) {
        const axisArray = [];
        let month = "";
        for (let i = 0; i < daysInRange; i++) {
            const nextDay = startDate.clone().add(i, "days");
            const nextMonth = nextDay.format("MMM");
            if (month !== nextMonth) {
                axisArray.push(nextDay.format("MMM D"));
                month = nextMonth;
            } else {
                axisArray.push(null);
            }
        }
        return axisArray;
    }
    
    constructor(props) {
        super(props);
        this.state = {
            chartDataLoaded: false,
            error: false
        };
    }
    
    componentDidMount() {
        const reactProps = this.props.subModel.get("trendline").reactProps;
        if (this.existingPromiseRequest) {
            this.existingPromiseRequest.cancel();
        }
    
        this.existingPromiseRequest = Promise.map(this.props.dateRanges, (r) => fetchChartData(r, this.props)).then((chartData) => {
            this.setState({
                error: false,
                chartDataLoaded: true,
                chartData: {
                    current: TrendlineTabBody.processData({
                        ...this.props,
                        countField: reactProps.countField,
                        countField2: reactProps.otherCountField
                    }, 0, chartData[0]),
                    axis: TrendlineTabBody.generateAxisArray(this.props.dateRanges[0].days, this.props.dateRanges[0].startDate),
                    previous: TrendlineTabBody.processData({
                        ...this.props,
                        countField: reactProps.countField,
                        countField2: reactProps.otherCountField
                    }, 1, chartData[1])
                }
            });
        }, (error) => {
            this.setState({
                loaded: true,
                error: true
            });
        });
    }
    
    componentWillUnmount() {
        if (this.existingPromiseRequest) {
            this.existingPromiseRequest.cancel();
        }
    }
    
    render() {
        if (this.state.error) {
            return (
                <ErrorView
                    captureInSentry={false}
                    error={new FetchErrorRetry({
                        message: "Please refresh widget as data could not load",
                        customActions: [{
                            className: "retry-widget",
                            label: "Refresh widget"
                        }],
                        hideDetails: true,
                        custom: true
                    })}
                />
            );
        }
        
        const style = {
            height: "60px",
            overflow: "hidden"
        };
        
        const trendLineSummaryOptions = {
            dateRanges: this.props.dateRanges,
            first_pivot_key: this.props.first_pivot_key,
            subModel: this.props.subModel,
            pivotName: this.props.pivotName,
            data: this.props.data,
            widgetSubType: this.props.widgetSubType,
            widgetQualifiers: this.props.widgetQualifiers
        };
        
        const trendLineChartOptions = {
            dateRanges: this.props.dateRanges, // really just used for drill through
            subModel: this.props.subModel, // really just used for drill through
            first_pivot_key: this.props.first_pivot_key, // really just  used for drill through
            widgetQualifiers: this.props.widgetQualifiers, // really just  used for drill through
            pivotName: this.props.pivotName, // really just  used for drill through
            widgetContainer: this.props.widgetContainer,
            widgetSubType: this.props.widgetSubType
        };
        
        if (this.state.chartDataLoaded) {
            const options = {
                ...trendLineChartOptions,
                chartData: this.state.chartData
            };
            
            return (
                <>
                    <div style={style}><TrendlineSummary {...trendLineSummaryOptions} count="topCount"/></div>
                    <div><TrendlineTopChart {...options}/></div>
                    <div style={style}><TrendlineSummary {...trendLineSummaryOptions} count="bottomCount"/></div>
                    <div><TrendlineBottomChart {...options}/></div>
                </>
            );
        }
        
        const chartStyle = {
            height: `${Math.round((this.props.widgetContainer.offsetHeight - 100 - 80) / 2)}px`
        };
        const loaderStyle = {
            paddingTop: "10px",
            width: "100%"
        };
        
        return (
            <>
                <div style={chartStyle}><TrendlineSummary {...trendLineSummaryOptions} count="topCount"/></div>
                <div style={style}><Loader style={loaderStyle} loaded={this.state.loaded} /></div>
                <div style={style}><TrendlineSummary {...trendLineSummaryOptions} count="bottomCount"/></div>
                <div style={chartStyle}><Loader style={loaderStyle} loaded={this.state.loaded} /></div>
            </>
        );
    }
}
